module.exports = __webpack_public_path__ + "png/quick-registration-dice-2.png?5b3c35c885c02b29e3f670796c888136";